
import { useEffect, useState } from 'react';


import Card from "../../components/card/Card";
import {linksConfig} from "../../linksConfig";

import "./Cards.css";
import Carousel from '../../components/carousel/carousel';

async function loadDataAllmeasures(setData,accessToken) {
  try {
  //  console.log('token in cards:'+accessToken)
   if(accessToken ===''){console.log('access token not obtained!')}
   var headers = new Headers();
   var bearer = "Bearer "+accessToken;
   headers.append("Authorization",bearer);
   var options={method:"GET",headers:headers};
   //console.log(`${linksConfig.link.apilink}/allmeasures`);
   await fetch(`${linksConfig.link.apilink}/allmeasures`,options)
   .then(response => response.json())
   .then(receiveData =>setData(receiveData))
  }catch(error){
   console.log(error)
  return('error');
}
 }

export default function Cards(Props) {

const [allData,setallData] = useState(['']);
useEffect( ()=> {
  loadDataAllmeasures(setallData,Props.accessToken);
},[Props.accessToken])
  return (
    <div className="cards_secnav" style={{ maxWidth: 1200, marginLeft: 'auto', marginRight: 'auto', marginTop: 64 }}>
     <Carousel show={3}>
     {allData!==''?allData.map((stage) => (
        <div className="cards_secnav_column" key={stage.stageName}>
          <div className="stage_name">{stage.stageName}</div>
          <br />

          {stage.sub.sec && (
            <div className="secmeasures">
              Cyber Security Requirements 
              <hr />
              <br />
              {stage.sub.sec.map((sm) => (
                <div key={sm.header}>
                  <Card title={sm.header} desc={sm.description} />
                </div>
              ))}
              <hr className="hr_item" />
            </div>
          )}

          {stage.sub.dat && (
            <div>
              <br />
              Data Privacy & Data Compliance Requirements
              <hr />
              <br />
              {stage.sub.dat.map((da) => (
                <div key={da.header}>
                  <Card  title={da.header} desc={da.description} />
                </div>
              ))}
              <hr className="hr_item" />
            </div>
          )}
        </div>
      )):<div></div>}
     </Carousel>
    </div>
  );
}
